import { css } from '@lastbrand/web-ui-styled-system/css'

export const preorderMessageWrapperDsClass = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: { base: 'flex-start', lg: 'center' },
  gap: 'space-8',
  textStyle: 'body-14',
  color: 'black',
  textAlign: 'center',
  marginBottom: 'space-16',
})

// Calendar icon: 20px (2rem), desktop-hidden / mobile-shown (legacy parity).
export const preorderCalendarIconDsClass = css({
  display: 'none',
  lgDown: { display: 'block', width: '20px', height: '20px' },
})

// "details" toggle: underlined, nudged left to align with the text (legacy margin-left -0.4rem).
export const preorderDetailsTextDsClass = css({
  cursor: 'pointer',
  marginLeft: '-4px',
  textDecoration: 'underline',
  textUnderlineOffset: 'space-2',
})
